import { render, staticRenderFns } from "./HRBreakComponent.vue?vue&type=template&id=e5f2fdb6&scoped=true&"
var script = {}
import style0 from "./HRBreakComponent.vue?vue&type=style&index=0&id=e5f2fdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f2fdb6",
  null
  
)

export default component.exports